import React, { useEffect, useState } from "react";
import LogInForm from "../../Molecules/Login/LogInForm";
import styles from "./LoginPage.module.css";
import Logo from "../../../assets/Imagess/LoginPageLogo.png";
import LoginVideo from "../../../assets/videos/DPA-Login.mp4";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ForgotPassword from "../../Molecules/Login/ForgotPassword";

const LoginPage = () => {
  const [showForgot, setShowForgot] = useState(false);

  return (
    <>
      <div className={styles["login-container"]}>
        <video autoPlay loop muted id={styles["background-video"]}>
          <source src={LoginVideo} type="video/mp4" />
        </video>
        <div className={styles["login-subContainer"]}>
          <div className={styles["login-sub-Container"]}>
            <img src={Logo} alt="logo" className={styles["logo-login"]} />
            <LogInForm setShowForgot={setShowForgot} />
            {showForgot && (
              <ForgotPassword
                title={"Forgot Password"}
                handleOnClose={() => setShowForgot(false)}
              />
            )}
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default LoginPage;
